/** The Workspace "…" menu item leading to the import page. */
export const IMPORT_FROM_FILE_LABEL = "Import…";

/** The item exporting one dashboard or template, in its "…" menus. */
export const EXPORT_AS_FILE_LABEL = "Export";

export function workspaceImportPath(from: "dashboards" | "templates") {
  return from === "templates" ? "/workspace/import?from=templates" : "/workspace/import";
}
